<template>
    <div class="bg-white flex flex-col md:rounded-lg shadow">
        <div
            v-if="!withoutHeader"
            class="header flex flex-row justify-between items-center mb-5"
        >
            <div class="flex flex-row items-center justify-start">
                <slot name="title-prefix"></slot>
                <h3
                    v-if="title"
                    class="text-xl md:text-2xl text-black lg:font-display-3 font-body-2-medium"
                    v-text="title"
                ></h3>
                <slot name="title-suffix"></slot>
            </div>
            <div>
                <slot name="header-options"></slot>
            </div>
        </div>
        <div class="h-full">
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Panel',
    props: {
        /**
         * Panel header title
         */
        title: {
            type: String,
            default: null,
        },
        /**
         * Hide the header
         */
        withoutHeader: {
            type: Boolean,
            default: false,
        },
    },
});
</script>
